module.exports = __webpack_public_path__ + "static/media/sportLight.12256a45.svg";